module.exports = __webpack_public_path__ + "img/cai5.5a815546.png";